import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import PlanningContextContent from "./PlanningContextContent";

interface OKR {
  id: string;
  objective: string;
  keyResults: {
    id: string;
    description: string;
    target: number;
    current: number;
    status: "on-track" | "at-risk" | "blocked" | "completed";
  }[];
}

interface PlanningCycle {
  type: "30-day" | "quarter" | "year" | "3-year";
  current: string;
  startDate: string;
  endDate: string;
  daysRemaining: number;
}

interface PlanningContextPanelProps {
  isOpen: boolean;
  onToggle: () => void;
  currentCycle: PlanningCycle;
  okrs: OKR[];
  onCycleChange?: (type: PlanningCycle["type"]) => void;
  onReviewClick?: () => void;
  onPlanNextCycle?: () => void;
}

const PlanningContextPanel: React.FC<PlanningContextPanelProps> = ({
  isOpen,
  onToggle,
  currentCycle,
  okrs,
  onCycleChange,
  onReviewClick,
  onPlanNextCycle,
}) => {
  return (
    <>
      {/* Toggle Button */}
      <button
        onClick={onToggle}
        className={`fixed right-0 top-1/2 -translate-y-1/2 bg-white border border-gray-300 rounded-l-md p-2 shadow-lg z-40 transition-all ${
          isOpen ? "translate-x-0" : "translate-x-0"
        }`}
      >
        {isOpen ? (
          <ChevronRightIcon className="w-5 h-5 text-gray-600" />
        ) : (
          <ChevronLeftIcon className="w-5 h-5 text-gray-600" />
        )}
      </button>

      {/* Panel */}
      <div
        className={`fixed right-0 top-0 h-full w-80 bg-white border-l border-gray-200 shadow-xl transform transition-transform duration-300 ease-in-out z-30 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <PlanningContextContent
          currentCycle={currentCycle}
          okrs={okrs}
          onCycleChange={onCycleChange}
          onReviewClick={onReviewClick}
          onPlanNextCycle={onPlanNextCycle}
        />
      </div>
    </>
  );
};

export default PlanningContextPanel;
